import { render, staticRenderFns } from "./SCFoot.vue?vue&type=template&id=30f79eba&scoped=true"
import script from "./SCFoot.vue?vue&type=script&lang=js"
export * from "./SCFoot.vue?vue&type=script&lang=js"
import style0 from "./SCFoot.vue?vue&type=style&index=0&id=30f79eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f79eba",
  null
  
)

export default component.exports